module.exports = __webpack_public_path__ + "img/L2M.688dc666.png";